import { Component, Input, OnInit, EventEmitter, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';

import { SearchParams } from './search-params.modal';
import { SearchControlService } from './search-control.service';
import { SearchReturn } from './search-return.modal';
import { Constants } from '../../constants';
import { SharedService } from '../../shared.service';
import { AlertService } from '../../alert/alert.service';

@Component({
    selector: 'symbiosis-search-form',
    templateUrl: './search-form.component.html',
    styleUrls: ['../symbiosis-search.component.css'],
    providers: [SearchControlService],
    outputs: ['searchClick', 'saveClick']
})
export class SearchFormComponent implements OnInit {

    @Input() searchParams: SearchParams<any>[] = [];
    @Input() comp: string;
    @Input() saveEnabled: boolean = false;
    @Output() saveClick = new EventEmitter<any>();
    form: FormGroup;
    payLoad = [];
    searchClick = new EventEmitter<any>()
    selectedCategoryItem: any = null;
    selectedDocType: any = null;
    tagInputItems = [];
    @Input() hasSavedDefault: boolean = false;
    @Input() savedDefaultValue: string = '';
    @Input() savedDefaultId: string = '';
    @Output() clearClick = new EventEmitter<any>();
    @Output() applyDefaultClick = new EventEmitter<any>();
    constructor(private scs: SearchControlService, private sharedService: SharedService, private alertService: AlertService) { }

    ngOnInit() {
        this.form = this.scs.toFormGroup(this.searchParams);
    }

    onSave() {
        if (this.comp === 'statement') {
            this.saveClick.emit(this.selectedCategoryItem);
            return;
        }
        let facilityKey = this.getFacilityKeyForComp();
        let facilityValue = facilityKey && this.form.get(facilityKey) ? this.form.get(facilityKey).value : null;
        this.saveClick.emit(facilityValue);
    }

    onClear() {
        this.clearClick.emit();
    }

    /**
     * Resets the field bound to the saved default pill back to the saved default value.
     * Does not clear the saved default itself - that is handled by onClear() via the 'x'.
     */
    onResetToDefault() {
        const fieldKey = this.getDefaultPillFieldKey();
        if (this.comp === 'statement') {
            this.selectedCategoryItem = { catId: this.savedDefaultId, catName: this.savedDefaultValue };
            SharedService.setStateCheck("true");
            this.applyDefaultClick.emit(this.selectedCategoryItem);
        } 
        if (fieldKey && this.form.get(fieldKey)) {
            this.form.get(fieldKey).setValue(this.savedDefaultValue);
        }
        this.alertService.clear();
        this.alertService.success('Reset to default value');
    }

    private getFacilityKeyForComp(): string {
        switch (this.comp) {
            case 'tag': return Constants.SEARCH_KEY_WORDS.SEARCH_TAG_TAG_FACILITY;
            case 'document': return Constants.SEARCH_KEY_WORDS.SEARCH_DOCUMENT_DOC_FACILITY;
            case 'system': return Constants.SEARCH_KEY_WORDS.SEARCH_SYSTEM_SYS_FACILITY;
            case 'facility': return Constants.SEARCH_KEY_WORDS.SEARCH_FACILITY_FAC_NAME;
            default: return null;
        }
    }

    public getDefaultPillFieldKey(): string {
        if (this.comp === 'statement') {
            return Constants.SEARCH_KEY_WORDS.SEARCH_STATEMENT_STM_CATEGORY;
        }
        return this.getFacilityKeyForComp();
    }

    public clearCurrentFieldValue() {
        if (this.comp === 'statement') {
            this.selectedCategoryItem = { catId: '', catName: '' };
        } else {
            const fieldKey = this.getFacilityKeyForComp();
            if (fieldKey && this.form.get(fieldKey)) {
                this.form.get(fieldKey).setValue('');
            }
        }
    }

    //search button click event
    onSubmit() {
        // console.log('[onSubmit] (SearchParams)' + JSON.stringify(this.searchParams));
        this.payLoad = []
        this.generatePayLoad()
        // console.log('[onSubmit] (this.payLoad) ' + JSON.stringify(this.payLoad) );
        this.searchClick.emit(this.payLoad)
    }

    /**
     * generate payload 
     */
    generatePayLoad() {
        this.searchParams.forEach(item => {
            // console.log('[generatePayLoad] ' + item.key + '-' + this.form.get(item.key).value);
           //alert( JSON.stringify(item));
           
            let srItem: SearchReturn = new SearchReturn()
            if(this.form.get(item.key).value == '') {
                if((item.key == Constants.SEARCH_KEY_WORDS.SEARCH_STATEMENT_STM_CATEGORY) || item.key == (Constants.SEARCH_KEY_WORDS.SEARCH_COMPONENT_COMP_CATEGORY) || item.key == (Constants.SEARCH_KEY_WORDS.SEARCH_CHK_CATEGORY)) {
                    srItem.key = item.key
                    if(this.selectedCategoryItem != null) {
                        srItem.value = this.selectedCategoryItem.catName;
                        this.payLoad.push(srItem)
                    } else {

                    }
                } else if((item.key == (Constants.SEARCH_KEY_WORDS.SEARCH_IMAGE_IMG_DOCTYPE)) || (item.key == (Constants.SEARCH_KEY_WORDS.SEARCH_DOCUMENT_DOC_DOCTYPE)) || 
                        (item.key == (Constants.SEARCH_KEY_WORDS.SEARCH_THREED_MODEL_DOCTYPE)) || (item.key == (Constants.SEARCH_KEY_WORDS.SEARCH_VIDEO_DOCTYPE))) {
                    srItem.key = item.key
                    if(this.selectedDocType != null) {
                        srItem.value = this.selectedDocType.docName;
                        this.payLoad.push(srItem)
                    } else {

                    }
                }  else if((item.key == (Constants.SEARCH_KEY_WORDS.SEARCH_IRN_VENDOR)) || (item.key == (Constants.SEARCH_KEY_WORDS.SEARCH_IRN_SYSTEM))  || (item.key == (Constants.SEARCH_KEY_WORDS.SEARCH_IRN_ASSET)) || (item.key == (Constants.SEARCH_KEY_WORDS.SEARCH_IRN_IRN_DESCRIPTION)) || (item.key == (Constants.SEARCH_KEY_WORDS.SEARCH_IRN_IRN_NUMBER)) 
                || (item.key == (Constants.SEARCH_KEY_WORDS.SEARCH_IRN_STATUS)) || (item.key == (Constants.SEARCH_KEY_WORDS.SEARCH_IRN_COMPLETION_DATE))  ){
                    srItem.key = item.key
                    srItem.value = []
                    this.tagInputItems.forEach((elment) => {
                        if(elment.key ==item.key){
                            srItem.value = elment.value
                        }
                    });
                    this.payLoad.push(srItem);
                } else if((item.key == (Constants.SEARCH_KEY_WORDS.SEARCH_MCC_SYSTEM)) || (item.key == (Constants.SEARCH_KEY_WORDS.SEARCH_MCC_STATUS)) || (item.key == (Constants.SEARCH_KEY_WORDS.SEARCH_MCC_COMPLETION_DATE)) ){
                    srItem.key = item.key
                    srItem.value = []
                    this.tagInputItems.forEach((elment) => {
                        if(elment.key ==item.key){
                            srItem.value = elment.value
                        }
                    });
                    this.payLoad.push(srItem);
                } else if((item.key == (Constants.SEARCH_KEY_WORDS.SEARCH_OTN_ASSET)) || (item.key == (Constants.SEARCH_KEY_WORDS.SEARCH_OTN_VENDOR)) || (item.key == (Constants.SEARCH_KEY_WORDS.SEARCH_OTN_STATUS)) || (item.key == (Constants.SEARCH_KEY_WORDS.SEARCH_OTN_COMPLETION_DATE)) ){
                    srItem.key = item.key
                    srItem.value = []
                    this.tagInputItems.forEach((elment) => {
                        if(elment.key ==item.key){
                            srItem.value = elment.value
                        }
                    });
                    this.payLoad.push(srItem);
                }
                else if( item.key === Constants.SEARCH_KEY_WORDS.SEARCH_ASSET_NO || item.key === Constants.SEARCH_KEY_WORDS.SEARCH_ASSET_DESC || item.key === Constants.SEARCH_KEY_WORDS.SEARCH_ASSET_SYS ||
                    item.key === Constants.SEARCH_KEY_WORDS.SEARCH_ASSET_GROUP || item.key === Constants.SEARCH_KEY_WORDS.SEARCH_ASSET_PARENT || item.key === Constants.SEARCH_KEY_WORDS.SEARCH_ASSET_FUNCCODE || item.key === Constants.SEARCH_KEY_WORDS.SEARCH_ASSET_ATTRIBUTE){
                    srItem.key = item.key
                    srItem.value = []
                    this.tagInputItems.forEach((elment) => {
                        if(elment.key ==item.key){
                            srItem.value = elment.value
                        }
                    });
                    this.payLoad.push(srItem);
                }
                else if(item.key === Constants.SEARCH_KEY_WORDS.SEARCH_SYS_NO ||  item.key === Constants.SEARCH_KEY_WORDS.SEARCH_SYS_NAME){
                    srItem.key = item.key
                    srItem.value = []
                    this.tagInputItems.forEach((elment) => {
                        if(elment.key ==item.key){
                            srItem.value = elment.value
                        }
                    });
                    this.payLoad.push(srItem);
                }
                else if(item.key === Constants.SEARCH_KEY_WORDS.ISSUE_CS_VENDOR || item.key === Constants.SEARCH_KEY_WORDS.ISSUE_CS_CHECKSHEET ||
                    item.key === Constants.SEARCH_KEY_WORDS.ISSUE_CS_ASSET || item.key === Constants.SEARCH_KEY_WORDS.ISSUE_CS_ASSET_DESCRIPTION ||
                    item.key === Constants.SEARCH_KEY_WORDS.ISSUE_CS_SYSTEM || item.key === Constants.SEARCH_KEY_WORDS.ISSUE_CS_ASSET_GROUP ||
                    item.key === Constants.SEARCH_KEY_WORDS.ISSUE_CS_PHASE || item.key === Constants.SEARCH_KEY_WORDS.ISSUE_CS_ASSET_PARENT ||
                    item.key === Constants.SEARCH_KEY_WORDS.ISSUE_CS_FUNCTION_CODE){
                    srItem.key = item.key
                    srItem.value = []
                    this.tagInputItems.forEach((elment) => {
                        if(elment.key ==item.key){
                            srItem.value = elment.value
                        }
                    });
                    this.payLoad.push(srItem); 
                }
                else if(item.key === Constants.SEARCH_KEY_WORDS.RECEIVE_CS_VENDOR || item.key === Constants.SEARCH_KEY_WORDS.RECEIVE_CS_CHECKSHEET ||
                    item.key === Constants.SEARCH_KEY_WORDS.RECEIVE_CS_ASSET || item.key === Constants.SEARCH_KEY_WORDS.RECEIVE_CS_ASSET_DESCRIPTION ||
                    item.key === Constants.SEARCH_KEY_WORDS.RECEIVE_CS_SYSTEM || item.key === Constants.SEARCH_KEY_WORDS.RECEIVE_CS_ASSET_GROUP ||
                    item.key === Constants.SEARCH_KEY_WORDS.RECEIVE_CS_PHASE || item.key === Constants.SEARCH_KEY_WORDS.RECEIVE_CS_FUNCTION_CODE){
                        srItem.key = item.key
                        srItem.value = []
                        this.tagInputItems.forEach((elment) => {
                            if(elment.key ==item.key){
                                srItem.value = elment.value
                            }
                        });
                        this.payLoad.push(srItem); 
                }
                else if((item.key == (Constants.SEARCH_KEY_WORDS.SEARCH_PCC_SYSTEM)) || (item.key == (Constants.SEARCH_KEY_WORDS.SEARCH_PCC_STATUS)) || (item.key == (Constants.SEARCH_KEY_WORDS.SEARCH_PCC_COMPLETION_DATE)) ){
                    srItem.key = item.key
                    srItem.value = []
                    this.tagInputItems.forEach((elment) => {
                        if(elment.key ==item.key){
                            srItem.value = elment.value
                        }
                    });
                    this.payLoad.push(srItem);
                } 
            } 
            else {
                if((item.key == Constants.SEARCH_KEY_WORDS.SEARCH_STATEMENT_STM_CATEGORY) || item.key == (Constants.SEARCH_KEY_WORDS.SEARCH_COMPONENT_COMP_CATEGORY) || item.key == (Constants.SEARCH_KEY_WORDS.SEARCH_CHK_CATEGORY)) {
                    srItem.key = item.key
                    if(this.selectedCategoryItem != null) {
                        srItem.value = this.selectedCategoryItem.catName;
                        this.payLoad.push(srItem)
                    } else {
                        srItem.value = this.form.get(item.key).value;
                        this.payLoad.push(srItem)
                    }
                } else if( item.key == (Constants.SEARCH_KEY_WORDS.SEARCH_IMAGE_IMG_DOCTYPE) || (item.key == (Constants.SEARCH_KEY_WORDS.SEARCH_DOCUMENT_DOC_DOCTYPE))
                            || (item.key == (Constants.SEARCH_KEY_WORDS.SEARCH_THREED_MODEL_DOCTYPE)) || (item.key == (Constants.SEARCH_KEY_WORDS.SEARCH_VIDEO_DOCTYPE))) {
                    srItem.key = item.key
                    if(this.selectedDocType != null) {
                        srItem.value = this.selectedDocType.docName;
                        this.payLoad.push(srItem)
                    } else {
                        srItem.value = this.form.get(item.key).value;
                        this.payLoad.push(srItem)
                    }
                } else if((item.key == (Constants.SEARCH_KEY_WORDS.SEARCH_IRN_VENDOR)) || (item.key == (Constants.SEARCH_KEY_WORDS.SEARCH_IRN_ASSET)) || (item.key == (Constants.SEARCH_KEY_WORDS.SEARCH_IRN_STATUS))
                || (item.key == (Constants.SEARCH_KEY_WORDS.SEARCH_IRN_COMPLETION_DATE)) ){
                    srItem.key = item.key
                    srItem.value = []
                    this.tagInputItems.forEach((elment) => {
                        if(elment.key ==item.key){
                            srItem.value = elment.value
                        }
                    });
                    this.payLoad.push(srItem);
                } else if((item.key == (Constants.SEARCH_KEY_WORDS.SEARCH_MCC_SYSTEM)) || (item.key == (Constants.SEARCH_KEY_WORDS.SEARCH_MCC_STATUS)) || (item.key == (Constants.SEARCH_KEY_WORDS.SEARCH_MCC_COMPLETION_DATE)) ){
                    srItem.key = item.key
                    srItem.value = []
                    this.tagInputItems.forEach((elment) => {
                        if(elment.key ==item.key){
                            srItem.value = elment.value
                        }
                    });
                    this.payLoad.push(srItem);
                } else if((item.key == (Constants.SEARCH_KEY_WORDS.SEARCH_OTN_ASSET)) || (item.key == (Constants.SEARCH_KEY_WORDS.SEARCH_OTN_VENDOR)) || (item.key == (Constants.SEARCH_KEY_WORDS.SEARCH_OTN_STATUS)) || (item.key == (Constants.SEARCH_KEY_WORDS.SEARCH_OTN_COMPLETION_DATE)) ){
                    srItem.key = item.key
                    srItem.value = []
                    this.tagInputItems.forEach((elment) => {
                        if(elment.key ==item.key){
                            srItem.value = elment.value
                        }
                    });
                    this.payLoad.push(srItem);
                }
                else if( item.key === Constants.SEARCH_KEY_WORDS.SEARCH_ASSET_NO || item.key === Constants.SEARCH_KEY_WORDS.SEARCH_ASSET_DESC || item.key === Constants.SEARCH_KEY_WORDS.SEARCH_ASSET_SYS ||
                    item.key === Constants.SEARCH_KEY_WORDS.SEARCH_ASSET_GROUP || item.key === Constants.SEARCH_KEY_WORDS.SEARCH_ASSET_PARENT || item.key === Constants.SEARCH_KEY_WORDS.SEARCH_ASSET_FUNCCODE || item.key === Constants.SEARCH_KEY_WORDS.SEARCH_ASSET_ATTRIBUTE){
                    srItem.key = item.key
                    srItem.value = []
                    this.tagInputItems.forEach((elment) => {
                        if(elment.key ==item.key){
                            srItem.value = elment.value
                        }
                    });
                    this.payLoad.push(srItem);
                }
                else if(item.key === Constants.SEARCH_KEY_WORDS.SEARCH_SYS_NO ||  item.key === Constants.SEARCH_KEY_WORDS.SEARCH_SYS_NAME){
                    srItem.key = item.key
                    srItem.value = []
                    this.tagInputItems.forEach((elment) => {
                        if(elment.key ==item.key){
                            srItem.value = elment.value
                        }
                    });
                    this.payLoad.push(srItem);
                }
                else if(item.key === Constants.SEARCH_KEY_WORDS.ISSUE_CS_VENDOR || item.key === Constants.SEARCH_KEY_WORDS.ISSUE_CS_CHECKSHEET ||
                    item.key === Constants.SEARCH_KEY_WORDS.ISSUE_CS_ASSET || item.key === Constants.SEARCH_KEY_WORDS.ISSUE_CS_ASSET_DESCRIPTION ||
                    item.key === Constants.SEARCH_KEY_WORDS.ISSUE_CS_SYSTEM || item.key === Constants.SEARCH_KEY_WORDS.ISSUE_CS_ASSET_GROUP ||
                    item.key === Constants.SEARCH_KEY_WORDS.ISSUE_CS_PHASE || item.key === Constants.SEARCH_KEY_WORDS.ISSUE_CS_ASSET_PARENT ||
                    item.key === Constants.SEARCH_KEY_WORDS.ISSUE_CS_FUNCTION_CODE){
                    srItem.key = item.key
                    srItem.value = []
                    this.tagInputItems.forEach((elment) => {
                        if(elment.key ==item.key){
                            srItem.value = elment.value
                        }
                    });
                    this.payLoad.push(srItem); 
                } else if(item.key === Constants.SEARCH_KEY_WORDS.RECEIVE_CS_VENDOR || item.key === Constants.SEARCH_KEY_WORDS.RECEIVE_CS_CHECKSHEET ||
                    item.key === Constants.SEARCH_KEY_WORDS.RECEIVE_CS_ASSET || item.key === Constants.SEARCH_KEY_WORDS.RECEIVE_CS_ASSET_DESCRIPTION ||
                    item.key === Constants.SEARCH_KEY_WORDS.RECEIVE_CS_SYSTEM || item.key === Constants.SEARCH_KEY_WORDS.RECEIVE_CS_ASSET_GROUP ||
                    item.key === Constants.SEARCH_KEY_WORDS.RECEIVE_CS_PHASE || item.key === Constants.SEARCH_KEY_WORDS.RECEIVE_CS_FUNCTION_CODE){
                        srItem.key = item.key
                        srItem.value = []
                        this.tagInputItems.forEach((elment) => {
                            if(elment.key ==item.key){
                                srItem.value = elment.value
                            }
                        });
                        this.payLoad.push(srItem); 
                    }
                    else if((item.key == (Constants.SEARCH_KEY_WORDS.SEARCH_PCC_SYSTEM)) || (item.key == (Constants.SEARCH_KEY_WORDS.SEARCH_PCC_STATUS)) || (item.key == (Constants.SEARCH_KEY_WORDS.SEARCH_PCC_COMPLETION_DATE)) ){
                        srItem.key = item.key
                        srItem.value = []
                        this.tagInputItems.forEach((elment) => {
                            if(elment.key ==item.key){
                                srItem.value = elment.value
                            }
                        });
                        this.payLoad.push(srItem);
                    } 
                else {
                    srItem.key = item.key
                    srItem.value = this.form.get(item.key).value
                    this.payLoad.push(srItem)
                }
            }
         });
    }

    /**
     * replace empty value
     * used in form 
     * @param value 
     */
    replaceEmptyValue(value) {
        if(value === '') {
            return undefined
        } 
        return value
    }

    categorySelected(event: any) {
        this.selectedCategoryItem = event
        if (this.comp === 'statement') {
            this.applyDefaultClick.emit(event);
        }
    }

    documentSelected(event: any) {
        this.selectedDocType = event
    }

    taginputSeleted(event: any){
        let key = event.key;
        this.tagInputItems = this.tagInputItems.filter( item => item.key != key);
        this.tagInputItems.push(event);
        console.log(this.tagInputItems);

        if(key == Constants.SEARCH_KEY_WORDS.SEARCH_ASSET_GROUP) {
            this.tagInputItems.forEach(tagInput => {
                if(tagInput.key == Constants.SEARCH_KEY_WORDS.SEARCH_ASSET_GROUP) {
                    if(tagInput.value.length == 1) {
                        this.searchParams.forEach(item => {
                            if(item.key == Constants.SEARCH_KEY_WORDS.SEARCH_ASSET_ATTRIBUTE) {                     
                                item.disable = false;
                            }
                        });
                    }
                    else {
                        this.searchParams.forEach(item => {
                            if(item.key == Constants.SEARCH_KEY_WORDS.SEARCH_ASSET_ATTRIBUTE) {  
                                this.tagInputItems = this.tagInputItems.filter(x => x.key != item.key);  
                                //this.sharedService.setTagInputList(item.key, []);          
                                item.disable = true;
                            }
                        });
                    }
                }
            });
        }
    }

    setDropdownValues() {
      for (let i = 0; i < this.searchParams.length; i++) {
        if(this.searchParams[i].key === 'filetype') {
            for (let j = 0; j < this.searchParams[i].options.length; j++) {
                if (this.searchParams[i].options[j].key === this.searchParams[i].value) {
                    this.form.controls['filetype'].setValue([{
                        id: this.searchParams[i].options[j].key , 
                        text: this.searchParams[i].options[j].value
                    }]);
                    break;
                }
            }
            break;
        } 
      }  
    }   
}
